// src/modules/app-views/offers/pages/Init/components/tableColumns/statusColumn.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Tag } from 'antd';
import translateX from 'utils/translateX';

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************
function statusColumn(buildColumnProps, options = {}) {
  const {
    key = 'status',
    title = 'status',
    dataIndex = 'status',
    width = 100,
    align = 'center',
    columnProps = { sort: true },
  } = options;

  return {
    key,
    title: translateX(title),
    dataIndex,
    width,
    align,
    ...buildColumnProps(dataIndex, columnProps),
    render: (_, r) => {
      const status = r?.status || 'draft';
      const cfg = {
        draft: { color: 'default', label: 'draft' },
        active: { color: 'success', label: 'active' },
        paused: { color: 'warning', label: 'paused' },
        finished: { color: 'error', label: 'finished' },
      };
      const { color, label } = cfg[status] || { color: 'default', label: status };
      return <Tag color={color}>{translateX(label)}</Tag>;
    },
  };
}

export default statusColumn;
